import axios from 'axios';

const API_URL = '/api/v1';

export const login = async ({ email, password }) => {
  const response = await axios.post(`${API_URL}/auth/login`, { email, password });
  return response.data;
};

export const signup = async ({ email, password, password_confirmation }) => {
  const response = await axios.post(`${API_URL}/auth/signup`, {
    email,
    password,
    password_confirmation
  });
  return response.data;
};

export const forgotPassword = async (email) => {
    await axios.post(`${API_URL}/auth/forgot_password`, { email });
};
  
export const resetPassword = async ({ token, password, password_confirmation }) => {
  const response = await axios.post(`${API_URL}/auth/reset_password`, {
      token,
      password,
      password_confirmation
  });
return response.data;
};
